<category-component></category-component>
<div class="fixed-header-height static-pages-header ">
    <h1>Privacy Policy</h1>
</div>
<div class=" grey-color static-pages side-space-wrapper static-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <ul class="breadcrumbs d-flex pt-3 pt-md-0">
                    <li>
                        <a routerLink="/" title="Home">Home</a>
                    </li>
                    <li>
                        <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                    </li>
                    <li>
                            Privacy Policy
                    </li>
                </ul>
             
                <div *ngFor="let item of firstSection; let i = index; 
                let even = even; let odd = odd" >
                <div class="content-block mt-0 mt-md-2 content-block-top" *ngIf="even">
                    <h2>{{item.heading}}</h2>
                    <div *ngFor="let para of item.content.raw.children">
                        <p *ngIf="even && para.type == 'paragraph'">{{para.children[0].text}}</p>
                        <ul *ngIf="even && para.type == 'bulleted-list'">
                            <li *ngFor="let data of para.children">{{data.children[0].children[0].text}}</li>
                            
                        </ul>
                    </div>
                    
                </div>
                <div class="content-block  mt-3" *ngIf="odd">
                    <h2>{{item.heading}}</h2>
                    <div *ngFor="let para of item.content.raw.children">
                        <p *ngIf="odd && para.type == 'paragraph'">{{para.children[0].text}}</p>
                        <ul *ngIf="odd && para.type == 'bulleted-list'">
                            <li *ngFor="let data of para.children">{{data.children[0].children[0].text}}</li>
                            
                        </ul>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>